import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { IMAGE_SERVER_URL_DEV } from "../../Constant/System";

const BannerOneSingle = ({ data, spaceBottomClass }) => {
  return (
    <div className="col-lg-4 col-md-4">
      <div
      
        className={`single-banner ${spaceBottomClass ? spaceBottomClass : ""}`}
      >
        <Link to={process.env.PUBLIC_URL + "/shop-grid-standard"}>
          {/* <img src={process.env.PUBLIC_URL + data.image} alt="" /> */}
          <img src={`${IMAGE_SERVER_URL_DEV}${data?.image}`} />
        </Link>
        <div className="banner-content">
          <h3  style={{textShadow:"1px 1px 4px #000"}}>{data?.caption1}</h3>
          <h4 style={{color: "white",textShadow:"2px 2px 5px #000"}}>
            {data?.caption2} 
            {/* <span>{data.price}</span> */}
          </h4>
          <Link to={process.env.PUBLIC_URL + "/shop-grid-standard"}>
            <i className="fa fa-long-arrow-right" style={{textShadow:"2px 2px 5px #000"}} />
          </Link>
        </div>
      </div>
    </div>
  );
};

BannerOneSingle.propTypes = {
  data: PropTypes.object,
  spaceBottomClass: PropTypes.string
};

export default BannerOneSingle;
